// extracted by mini-css-extract-plugin
export default {"catagory":"catagory_catagory__w8Q6L","catagory__container":"catagory_catagory__container__vFT9s"};